import { attribute, autoGeneratedHashKey } from '@awslabs-community-fork/dynamodb-data-mapper-annotations';
import { dynamicTableName } from '@pristine-ts/aws';
import { CalculationStatusEnum } from '../enums/calculations/calculation-status.enum';
import { CalculationKeynameEnum } from '../enums/calculations/calculation-keyname.enum';
import { array } from '@pristine-ts/data-mapping-common';
import { property } from '@pristine-ts/metadata';


@dynamicTableName('CALCULATION_TABLE_NAME')
export class CalculationModel {
  @autoGeneratedHashKey()
  @property()
  id: string;
  @attribute()
  @property()
  mandateId?: string;
  @attribute()
  @property()
  ownerId: string;
  @attribute()
  @property()
  organizationId: string;
  @attribute()
  @property()
  calculationKeyname: CalculationKeynameEnum;
  @attribute()
  @property()
  title: string;
  @attribute()
  @property()
  executionStart: Date;
  @attribute()
  @property()
  executionEnd: Date;
  @attribute()
  @property()
  status: CalculationStatusEnum;
  @attribute()
  @property()
  resultId?: string;
  @attribute()
  @property()
  createdAt: Date;
  @attribute()
  @property()
  updatedAt: Date;
  @attribute()
  @property()
  isSimulationIntermediaryCalculation: boolean = false;
  @array(String)
  @attribute()
  simulationChildIntermediaryCalculationIds: string[] = [];
  @attribute()
  @property()
  accessDelegatedToAdminUntil: Date;
  @attribute()
  @property()
  parentCalculationId?: string;
  @attribute()
  @property()
  customerId?: string;
}
